import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  OutlinedInput,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import { Formik } from "formik";
import * as yup from "yup";
import { EditarUSersGeneral } from "../../../domain/api/UsersApi";
import { useDispatch } from "react-redux";
import { Store } from "react-notifications-component";

const validationSchema = yup.object().shape({
  nombre: yup.string().required("Por favor ingresa un nombre"),
  telefono: yup.string().required("Por favor ingresa un teléfono"),
  email: yup.string().email("Ingresa un email válido").required("Por favor ingresa un email"),
  username: yup.string().required("Por favor ingresa un nombre de usuario"),
  password: yup.string().required("Por favor ingresa una contraseña").matches(/^(?=.*[a-zA-Z])(?=.*[0-9])/, "La contraseña debe contener letras y números")
});
const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '20px',
    backgroundColor: 'white',
    color: '#2196F3',
    padding: '16px',
    display: 'flex',
    justifyContent: 'Center',
    alignItems: 'center',
    fontWeight: 'bold'
  },
}));
const EditUserModal = ({ reload, clearData, data,primaryColor }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispath = useDispatch();
  const classes = useStyles();


  const handledAlert = (title, message, type) => {
    Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true
      }
    });
    setTimeout(() => {
      setIsLoading(false);
      reload();
      clearData();
    }, 1000);
  }

  const handleEditClick = async (values) => {
    try {

      setIsLoading(true);

      const request = {
        id: data.id,
        name: values.nombre,
        phone: values.telefono,
        email: values.email,
        username: values.username,
        opt: ""
      };


      const response = await EditarUSersGeneral(dispath, request);
      try {

        if (response) {
          handledAlert("Actualizado Exitosamente!", `Usuario ${values.nombre} editado con exito!`, "success")

        } else {
          handledAlert("Ocurrio un erro!", "Ocurrio un error al cambiar el estado", "danger")
        }

      } catch {
        handledAlert("Ocurrio un erro!", "Error interno", "danger")
      }


    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };



  return (
    <Dialog open={true} onClose={clearData}>
      <DialogTitle className={classes.title} style={{color:primaryColor}} >Editar Usuario</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            nombre: data.name,
            telefono: data.phone,
            email: data.email,
            username: data.username,
          }}
          validationSchema={validationSchema}
          onSubmit={() => { }} // No necesitas onSubmit para editar, así que mantenlo vacío
        >
          {({ values, errors, touched, handleSubmit, handleChange, handleBlur, resetForm }) => (
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="nombre">Nombre</InputLabel>
                    <OutlinedInput
                      type="nombre"
                      id="nombre"
                      name="nombre"
                      value={values.nombre}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      labelWidth={60}
                      style={{ borderRadius: '10px' }}
                    />
                  </FormControl>
                  {touched.nombre && errors.nombre && <div style={{ color: "red" }}>{errors.nombre}</div>}
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="telefono">Teléfono</InputLabel>
                    <OutlinedInput
                      type="telefono"
                      id="telefono"
                      name="telefono"
                      value={values.telefono}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      labelWidth={75}
                      style={{ borderRadius: '10px' }}

                    />
                  </FormControl>
                  {touched.telefono && errors.telefono && <div style={{ color: "red" }}>{errors.telefono}</div>}
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="email">Email</InputLabel>
                    <OutlinedInput
                      type="correo"
                      id="email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      labelWidth={45}
                      style={{ borderRadius: '10px' }}

                    />
                  </FormControl>
                  {touched.email && errors.email && <div style={{ color: "red" }}>{errors.email}</div>}
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="username">Nombre de Usuario</InputLabel>
                    <OutlinedInput
                      type="username"
                      id="username"
                      name="username"
                      value={values.username}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      labelWidth={140}
                      style={{ borderRadius: '10px' }}

                    />
                  </FormControl>
                  {touched.username && errors.username && <div style={{ color: "red" }}>{errors.username}</div>}

                </Grid>
              </Grid>
              <DialogActions>
                <Button onClick={clearData} color="primary">
                  Cancelar
                </Button>
                <Button
                  onClick={() => handleEditClick(values, resetForm)} // Usar onClick para editar
                  color="primary"
                  disabled={isLoading}
                >
                  {isLoading ? "Editando..." : "Editar Usuario"}
                </Button>
                {isLoading && <CircularProgress size={24} />}
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default EditUserModal;